import { C8Node, cnl } from "csi/typings";

class ReflectionClassConfig {
	readonly m_xml: C8Node;
	readonly m_settings: C8Node;
	readonly m_phases: C8Node[];
	readonly m_subtypes: C8Node[];

	getUrl(): cnl {
		return this.m_xml.$URL;
	}

	getPdfViewId(): string {
		return this.m_xml.PdfViewId;
	}

	getPhases(): C8Node[] {
		return this.m_phases;
	}

	getProperty(propertyName: string): any {
		return this.m_xml[propertyName];
	}

	getSettings(): C8Node {
		return this.m_settings;
	}

	/** return url of subtype with given name */
	getSubtypeUrlByName(name: string): cnl | undefined {
		return this.m_subtypes?.find((node) => node.$Name === name)?.$URL;
	}

	getSubtypes(): C8Node[] {
		return this.m_subtypes || [];
	}

	isSiloCustomViewsBySubtype(): boolean {
		return this.m_xml.SiloCustomViewsBySubtype;
	}

	constructor(obj: C8Node, settings: C8Node, phases: C8Node[], subtypes: C8Node[]) {
		this.m_xml = obj;
		this.m_phases = phases;
		this.m_settings = settings;
		this.m_subtypes = subtypes;
	}
}

export = ReflectionClassConfig;
